import { Component } from '@angular/core';

@Component({ selector: 'p-loopback', template: '' })
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class LoopbackComponent {
    static readonly __componentName__ = 'LoopbackComponent';
}
